import {
  useAddRebarMaterials,
  useDeleteRebarMaterials,
  useRebarMaterials,
} from "@api/rebarMaterial";

import {
  useAddNonModelledMaterials,
  useDeleteNonModelledMaterials,
  useNonModelledMaterials,
} from "@api/nonModelledFamily";

export function useMaterialApisByType(type: string) {
  const isRebar = type === "rebar-material";

  const actualType = isRebar ? type : "ModelFamily";

  const rebarData = useRebarMaterials({ enabled: isRebar });
  const rebarAdd = useAddRebarMaterials();
  const rebarDelete = useDeleteRebarMaterials();

  const nonModelledData = useNonModelledMaterials(actualType, { enabled: !isRebar });
  const nonModelledAdd = useAddNonModelledMaterials(actualType);
  const nonModelledDelete = useDeleteNonModelledMaterials();

  return {
    isRebar,
    useData: isRebar ? rebarData : nonModelledData,
    useAdd: isRebar ? rebarAdd : nonModelledAdd,
    useDeleteRebar: rebarDelete,
    useDeleteNonModelled: nonModelledDelete,
  };
}
